import { FC } from 'react';

import Table from 'modules/_shared/Table';

import ObservationsSectionTableHeader from './ObservationsSectionTableHeader';
import ObservationsSectionTableBody from './ObservationsSectionTableBody';

const ObservationsSectionTable: FC = () => {
  const tableContent = (
    <>
      <ObservationsSectionTableHeader />
      <ObservationsSectionTableBody />
    </>
  );

  return (
    <div className="card card-bordered card-preview">
      <Table content={tableContent} />
    </div>
  );
};

export default ObservationsSectionTable;
